// tslint:disable

import * as React from 'react';
import { DatepickerField } from '../../components/fields/datepicker.field';
import { InputField } from '../../components/fields/input.field';
import { IriField } from '../../components/fields/iri.field';
import { JsonField } from '../../components/fields/json.field';
import { TextAreaField } from '../../components/fields/textarea.field';
import { Field, FormLib } from '../../components/libs/form.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import { get } from 'lodash';
import { MediaItemField } from '../../components/fields/media-item.field';
import { ResourceModal } from '../../components/structurals/resource-modal';
import {CheckboxField} from "../../components/fields/checkbox.field";
import {ContentBuilderField} from "../../components/fields/contentBuilder.field";

export class DefaultPerson extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);
    public state: any = {
        country: null,
        setUser: null
    };

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    handleCountryChange(value: any) {
        value = value.replace('/country/', '');
        this.setState({country: value});
    }

    handleCityCreated(city: any, form: FormLib) {
        form.fields.city.setValue(get(city, '@id'))
    }

    handleCountryCreated(country: any, form: FormLib) {
        form.fields.country.setValue(get(country, '@id'))
    }

    render() {
        return (
            <ResourceLoader entity="person" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div className="row">
                <LoaderComponent isLoading$={this.executor.loading$}/>

                <div className="col-xs-12">
                    <div id="page-title">
                        <h2>Update person details</h2>
                    </div>
                </div>

                <div className="col-xs-12 col-lg-9">
                    <ToggleBoxComponent title="Personal informations" alwaysOpen={true} color="green" preIcon="fa-user">
                        <div className="row">
                            <div className="col-xs-12">
                                <IriField
                                    field={form.fields.title}
                                    defaultAll={true}
                                    itemRender={(item: any) => get(item, 'name', '-')}

                                    validators={[Validators.required('Required')]}/>

                                <InputField
                                    field={form.fields.firstName}
                                    defaultValue={this.props.CONFIG.firstName}
                                    disabled={this.props.CONFIG.firstName}
                                    validators={[Validators.required('Required')]}/>

                                <InputField
                                    title={"Surname"}
                                    field={form.fields.surName}
                                    defaultValue={this.props.CONFIG.surName}
                                    disabled={this.props.CONFIG.surName}
                                    validators={[Validators.required('Required')]}/>


                                <IriField
                                    field={form.fields.user}
                                    forceQuery={{'_emptyRelation':'person', limit: 30}}
                                    defaultValue={this.props.CONFIG.user ? this.props.CONFIG.user: ''}
                                    disabled={this.props.CONFIG.user ? true : false}
                                    itemRender={(item: any) => `${get(item, 'firstName', '-')} ${get(item, 'surName', '-')} - ${get(item, 'email', '-')}`}
                                    />
                                {!form.fields.user.value || this.state.setUser &&
                                <ResourceModal
                                    entity="modal-user"
                                    entityId="create"
                                    extClass="btn-xs"
                                    config={{
                                        person: `/person/${this.props.ENTITY_ID}`,
                                        firstName: form.fields.firstName.value,
                                        surName: form.fields.surName.value,
                                        email: form.fields.email.value
                                    }}
                                    onCreateSuccessful={(value: any) => {
                                        this.state.setUser(true)
                                        form.fields.user.setValue(get(value, '@id'), false, true)
                                    }}
                                    title={<div><i className="fa fa-plus"/> Attach new user to the person</div>}/>
                                }
                                <DatepickerField
                                    field={form.fields.birthDate}/>

                                <CheckboxField
                                    field={form.fields.author}
                                />
                            </div>
                        </div>
                    </ToggleBoxComponent>

                    <ToggleBoxComponent title="Contacts" alwaysOpen={true} color="green">
                        <div className="row">
                            <div className="col-xs-12">
                                <InputField
                                    field={form.fields.website}
                                    validators={[Validators.isWebsite('Invalid website address')]}/>

                                <InputField
                                    field={form.fields.email}
                                    defaultValue={this.props.CONFIG.email}
                                    disabled={this.props.CONFIG.email}
                                    type="email"
                                    validators={[Validators.isEmail('Invalid email address')]}/>

                                <InputField
                                    field={form.fields.phone}
                                    validators={[Validators.isPhoneNumber('Required')]}/>

                                <IriField
                                    field={form.fields.country}
                                    onChange={(value: any) => this.handleCountryChange(value)}
                                    itemRender={(item: any) => get(item, 'title', '-')}
                                />
                                <ResourceModal
                                    extClass="btn-xs"
                                    entity="country"
                                    entityId="create"
                                    onCreateSuccessful={(value: any) => this.handleCountryCreated(value, form)}
                                    title={<div><i className="fa fa-plus"/> Add new Country</div>}
                                />

                                {this.state.country &&
                                    <IriField
                                        field={form.fields.city}
                                        forceQuery={{country: this.state.country}}
                                        itemRender={(item: any) => get(item, 'title', '-')}
                                    />
                                }
                                {this.state.country &&
                                    <ResourceModal
                                        extClass="btn-xs"
                                        entity="city"
                                        entityId="create"
                                        config={{country: this.state.country}}
                                        onCreateSuccessful={(value: any) => this.handleCityCreated(value, form)}
                                        title={<div><i className="fa fa-plus"/> Add new city to selected Country</div>}
                                    />
                                }

                                <InputField
                                    field={form.fields.postCode}
                                    />

                                <InputField
                                    field={form.fields.address}
                                    />


                                <JsonField
                                    title={'Social links'}
                                    schema={{
                                        facebook: (schemaField: Field) => <InputField field={schemaField}/>,
                                        instagram: (schemaField: Field) => <InputField field={schemaField}/>,
                                        youtube: (schemaField: Field) => <InputField field={schemaField}/>,
                                        twitter: (schemaField: Field) => <InputField field={schemaField}/>
                                    }}
                                    field={form.fields.socialLinks}
                                />

                            </div>
                        </div>
                    </ToggleBoxComponent>


                    <ToggleBoxComponent title="Description / Bio">
                        <ContentBuilderField
                            field={form.fields.description}
                            height={800}
                        />
                    </ToggleBoxComponent>

                    <ToggleBoxComponent title="Media">
                        <ContentBuilderField
                            field={form.fields.media}
                            height={800}
                        />
                    </ToggleBoxComponent>

                    <ToggleBoxComponent title="Links">
                        <ContentBuilderField
                            field={form.fields.links}
                            height={800}
                        />
                    </ToggleBoxComponent>

                    {this.props.ENTITY_ID !== 'create' &&
                        <ToggleBoxComponent title="Connected companies" color="blue" closed={true} preIcon="fa-building">
                            <ListResourceLoader
                                entity="person-company"
                                forceQuery={{person: this.props.ENTITY_ID, pagination: false}}
                                render={(list: ListLib) => <div className="w-100">
                                    <LoaderComponent isLoading$={list.isLoading$}/>

                                    <ListResponsePresenterTable
                                        head={() => this.personCompanyHead()}
                                        row={(item: any, index: number, actions: ListActions) => this.personCompanyRow(item, index, actions, list)}
                                        items={list.member}/>

                                    <ResourceModal
                                        entity="modal-person-company"
                                        entityId="create"
                                        config={{person: this.props.ENTITY_ID}}
                                        onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                        title={<div><i className="fa fa-plus"/> Attach new company to the person</div>}/>

                                </div>}/>

                        </ToggleBoxComponent>
                    }

                </div>

                <div className="col-xs-12 col-lg-3">
                    <ToggleBoxComponent title="Image" alwaysOpen={true} color="green" preIcon="fa-image">
                        <div className="row">
                            <div className="col-xs-12">
                                <MediaItemField
                                    field={form.fields.avatar}/>
                            </div>
                        </div>
                    </ToggleBoxComponent>
                    <ToggleBoxComponent title="Properties" alwaysOpen={true} color="green" preIcon="fa-cogs">
                        <div className="row">
                            <div className="col-xs-12">
                                <IriField
                                    className="col-xs-12"
                                    field={form.fields.guestType}
                                    defaultAll={true}
                                    itemRender={(item: any) => get(item, 'title', '-')}
                                    />

                                <InputField
                                    className="col-xs-12"
                                    field={form.fields.currentPointValue}
                                    disabled={true}/>

                                <InputField
                                    className="col-xs-12"
                                    field={form.fields.pointYear}
                                    disabled={true}/>

                                <InputField
                                    className="col-xs-12"
                                    field={form.fields.recommendedBy}
                                    disabled={true}/>

                                <DatepickerField
                                    className="col-xs-12"
                                    field={form.fields.createdAt}
                                    disabled={true}/>

                                <DatepickerField
                                    className="col-xs-12"
                                    field={form.fields.updatedAt}
                                    disabled={true}/>
                            </div>

                        </div>
                    </ToggleBoxComponent>

                    <ToggleBoxComponent title="Others">
                        <TextAreaField field={form.fields.consortia}/>
                    </ToggleBoxComponent>
                </div>

                <div className="col-xs-12">
                    <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                </div>

            </div>}
            />
        );
    }

    handleCreateAndUpdate(pc: any, list: ListLib) {
        list.refetch();
    }

    private personCompanyHead() {
        return <tr>
            <th>ID</th>
            <th>Company</th>
            <th>Job</th>
            <th>Action</th>
        </tr>;

    }

    private personCompanyRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>

                <IriPresenter iri={get(item, 'company.@id')} render={(person: any) =>
                    get(person, 'name')
                }/>

            </td>
            <td>

                <IriPresenter iri={get(item, 'job.@id')} render={(job: any) =>
                    get(job, 'title')
                }/>

            </td>
            <td>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'modal-person-company'}
                        config={{disabledPerson: true}}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        entityId={item.id || item['@id'].replace('/person-company/', '')}
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>

                </div>
            </td>
        </tr>;
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.person.tsx